import { render } from "./ActiveSession.vue?vue&type=template&id=4c71e95c"
import script from "./ActiveSession.vue?vue&type=script&lang=js"
export * from "./ActiveSession.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__